import { css } from 'styled-components';

export default css`
  :root {
    ${({ theme }) => css`
      --primary: ${theme.colors.primary500};
      --secondary: ${theme.colors.secondary500};
      --success: ${theme.colors.success500};
      --info: ${theme.colors.info500};
      --warning: ${theme.colors.warning500};
      --danger: ${theme.colors.danger500};
    `}
  }

  .badge-primary {
    background-color: ${props => props.theme.colors.primary500};
  }

  .form-control {
    border-radius: 8px;

    &::placeholder {
      font-size: 12px;
      color: hsl(0, 0%, 50%);
    }

    &:focus {
      box-shadow: ${props => props.theme.colors.semantic.shadow.sm};
      border-color: ${props => props.theme.colors.primary500};
    }

    &:hover {
      border-color: ${props => props.theme.colors.primary500};
    }
  }

  .nav-link {
    font-size: 14px;
  }

  .table {
    color: ${({ theme }) => theme.colors.semantic.text.primary};
  }

  .table th,
  .table td {
    border-color: ${({ theme }) => theme.colors.semantic.border.subtle};
  }

  .table thead th {
    color: ${({ theme }) => theme.colors.semantic.text.secondary};
    border-bottom-color: ${({ theme }) => theme.colors.semantic.border.default};
  }

  .table-striped tbody tr:nth-of-type(odd) {
    background-color: ${({ theme }) => theme.colors.semantic.surface.muted};
  }

  .table-hover tbody tr:hover {
    background-color: ${({ theme }) => theme.colors.semantic.surface.muted};
  }

  .custom-switch .custom-control-input {
    &:focus ~ .custom-control-label:before {
      box-shadow: 0 0 0 0.2rem ${props => props.theme.colors.primary100};
    }
    &:focus:not(:checked) ~ .custom-control-label::before {
      border-color: ${props => props.theme.colors.primary500};
    }
    &:checked ~ .custom-control-label::before {
      border-color: ${props => props.theme.colors.primary500};
      background-color: ${props => props.theme.colors.primary500};
    }

    &:disabled:checked ~ .custom-control-label::before {
      background-color: ${props => props.theme.colors.primary200} !important;
      border-color: ${props => props.theme.colors.primary200} !important;
    }

    &[disabled] ~ .custom-control-label::before {
      background-color: ${({ theme }) =>
        `${theme.colors.semantic.surface.card} !important`};
    }
  }
`;
